// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TXi7r4uSvj5pH5rUvITU{font-weight:bolder}`, "",{"version":3,"sources":["webpack://./src/app/menu/moncompte/MonCompte.scss"],"names":[],"mappings":"AAEA,sBACE,kBAAA","sourcesContent":["@use \"src/css/global.scss\";\n\n.userName {\n  font-weight: bolder;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userName": `TXi7r4uSvj5pH5rUvITU`
};
export default ___CSS_LOADER_EXPORT___;
